"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CLINIC_PHONE_PATTERN () {
        return CLINIC_PHONE_PATTERN;
    },
    get CLINIC_POSTAL_CODE_PATTERN () {
        return CLINIC_POSTAL_CODE_PATTERN;
    },
    get CLINIC_PROFILE_LIMITS () {
        return CLINIC_PROFILE_LIMITS;
    },
    get ClinicProfileSchema () {
        return ClinicProfileSchema;
    },
    get clinicProfileShape () {
        return clinicProfileShape;
    }
});
const _zod = require("zod");
const CLINIC_PROFILE_LIMITS = {
    name: 120,
    addressLine1: 120,
    addressLine2: 120,
    city: 80,
    province: 80,
    phone: 60
};
const CLINIC_POSTAL_CODE_PATTERN = /^[0-9]{4}$/;
const CLINIC_PHONE_PATTERN = /^[0-9+()\-/,. ]+$/;
/** Required single-line text: trimmed, then 1 to `max` characters. */ const requiredText = (max, label)=>_zod.z.string({
        message: `${label} is required.`
    }).trim().min(1, {
        message: `${label} is required.`
    }).max(max, {
        message: `${label} must be at most ${String(max)} characters.`
    });
/**
 * Optional text: trimmed; blank, `null` and absent all become `null`, so the
 * stored and returned value is never `""`. Mirrors `optionalText` in
 * `patients/patient-create.ts`, with `null` instead of `undefined` because a
 * branch `PUT` replaces the whole profile. Messages are fixed strings and never
 * quote the value.
 */ const optionalText = (max, label, pattern)=>_zod.z.string({
        message: `${label} must be text.`
    }).trim().max(max, {
        message: `${label} must be at most ${String(max)} characters.`
    }).refine((value)=>value === '' || pattern === undefined || pattern.regex.test(value), {
        message: pattern?.message ?? `${label} is not valid.`
    }).nullable().optional().transform((value)=>{
        if (value === undefined || value === null || value === '') {
            return null;
        }
        return value;
    });
const clinicProfileShape = {
    name: requiredText(CLINIC_PROFILE_LIMITS.name, 'Clinic name'),
    addressLine1: requiredText(CLINIC_PROFILE_LIMITS.addressLine1, 'Address line 1'),
    addressLine2: optionalText(CLINIC_PROFILE_LIMITS.addressLine2, 'Address line 2'),
    city: requiredText(CLINIC_PROFILE_LIMITS.city, 'City / municipality'),
    province: optionalText(CLINIC_PROFILE_LIMITS.province, 'Province'),
    // The pattern is the limit; `max` only bounds the input before the check.
    postalCode: optionalText(16, 'Postal code', {
        regex: CLINIC_POSTAL_CODE_PATTERN,
        message: 'Postal code must be 4 digits.'
    }),
    phone: optionalText(CLINIC_PROFILE_LIMITS.phone, 'Phone', {
        regex: CLINIC_PHONE_PATTERN,
        message: 'Phone may contain only digits, spaces and + ( ) - / , .'
    })
};
const ClinicProfileSchema = _zod.z.object(clinicProfileShape).strict();
